import { defineSlotRecipe } from '@chakra-ui/react';

export const switchStickyBarSlotRecipe = defineSlotRecipe({
    slots: ['wrapper'],
    base: {
        wrapper: {
            display: 'flex',
            py: 2,
            gap: 'gutterWidth',
            alignItems: 'center',
            justifyContent: 'space-between',
            left: 0,
            right: 0,
            transition: 'transform .3s, visibility .3s, opacity .3s',
            _before: {
                zIndex: -1,
                content: '""',
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                height: '100%',
                background:
                    'linear-gradient(180deg, rgba(22, 34, 42, 0) 10%, rgba(22, 34, 42, 0.5))',
            },
        },
    },
});
